(() => {
    "use strict";

    // ============================================================
    // PART 1: SUB-NAV DROPDOWNS (Accordion Style)
    // ============================================================
    const dropdownButtons = document.querySelectorAll('.dropdown-toggle');

    const closeAllSubnavs = (currentButton = null) => {
        dropdownButtons.forEach(button => {
            if (button !== currentButton) {
                const parent = button.parentElement;
                parent.classList.remove('is-open');
                button.setAttribute('aria-expanded', 'false');
            }
        });
    };

    dropdownButtons.forEach(button => {
        button.addEventListener('click', (e) => {
            e.preventDefault(); // Stop any default button behavior
            const parent = button.parentElement;
            const isOpen = parent.classList.contains('is-open');

            // Accordion Logic: Close other open sub-menus
            closeAllSubnavs(button);

            // Toggle current sub-menu
            parent.classList.toggle('is-open', !isOpen);
            button.setAttribute('aria-expanded', !isOpen);
        });
    });

    // ============================================================
    // PART 2: MOBILE MENU (Main Toggle)
    // ============================================================
	const mobileMenu = document.getElementById('mobileMenu');
    const mobileOpenBtn = document.getElementById('mobileOpen');
    
	if (mobileMenu) {
        // The 'toggle' event fires whenever the popover opens or closes
        mobileMenu.addEventListener('toggle', (event) => {
            const isOpen = event.newState === 'open';

            // 1. Toggle the scroll lock class on the body
            document.body.classList.toggle('no-scroll', isOpen);

            // 2. Update the ARIA state on the trigger button
            if (mobileOpenBtn) {
                mobileOpenBtn.setAttribute('aria-expanded', isOpen);
            }
        });

        // Close menu when a direct navigation link is clicked
        mobileMenu.addEventListener('click', (e) => {
            const link = e.target.closest('a');
            // Ensure it's a real link and not a dropdown toggle
            if (link && !e.target.closest('.dropdown-toggle')) {
                mobileMenu.hidePopover();
            }
        });
    }

    // ============================================================
    // PART 3: GLOBAL CLEANUP
    // ============================================================
    window.addEventListener('click', (e) => {
        // Close sub-navs if clicking outside the nav-item
        if (!e.target.closest('.nav-item')) {
            closeAllSubnavs();
        }

        // Close mobile menu if clicking the background overlay
        if (document.body.classList.contains('mobileMenuOpen')) {
            if (!e.target.closest('#mobileMenu') && !e.target.closest('#mobileOpen')) {
                toggleMobileMenu();
            }
        }
    });

})();